let projectionMatrix = 'simd_float4x4([[1.5482887, 0.0, 0.0, 0.0], [0.0, 3.3508859, 0.0, 0.0], [-0.003903985, -0.062301278, -1.000001, -1.0], [0.0, 0.0, -0.001000001, 0.0]])'
let transformCameraMatrix = 'simd_float4x4([[0.9669857, -0.017672006, 0.2542169, 0.0], [0.07753503, 0.97069854, -0.2274478, 0.0], [-0.24274854, 0.23964946, 0.9400219, 0.0], [-0.06311529, -0.042848814, 0.007702188, 0.9999999]])'
let arrow3 = 'simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.091951884, -0.12102479, -0.24678656, 1.0]])';
let arrow4 = 'simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [0.034943573, -0.11186692, -0.17945227, 1.0]])';
let arrow1 = 'simd_float4x4([[1.0, 0.0, 0.0, 0.0], [0.0, 1.0, 0.0, 0.0], [0.0, 0.0, 1.0, 0.0], [-0.1626853, -0.15665998, -0.2881741, 1.0]])'

export {
  projectionMatrix,
  transformCameraMatrix,
  arrow1,
  arrow3,
  arrow4
}
